(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-brand"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('about-brand')) {
    customElements.define(
      'about-brand',
      class AboutBrand extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';

          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (reduced || !('IntersectionObserver' in window)) return;

          this.classList.add('about--animate');

          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                entry.target.classList.add('is-in');
                observer.unobserve(entry.target);
              });
            },
            { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
          );

          this.querySelectorAll('[data-reveal]').forEach((el) => observer.observe(el));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artikel-seite"] && !Shopify.designMode) return;
  try {
    
  /* Einblenden beim Scrollen. Ohne JavaScript bleibt alles sichtbar; erst die
     Klasse jx--animate versteckt die Elemente, die der Observer dann einblendet.
     Sucht den Scroll-Container nicht selbst — IntersectionObserver funktioniert
     auch in Horizons .page-wrapper, weil er sich am Viewport orientiert. */
  class ArtikelSeite extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      this.querySelectorAll('.jx').forEach((root) => {
        if (root.dataset.ready === 'true') return;
        root.dataset.ready = 'true';
        root.classList.add('jx--animate');
        root.querySelectorAll('[data-reveal]').forEach((el, i) => {
          el.style.animationDelay = (i % 3) * 70 + 'ms';
          io.observe(el);
        });
      });
    }
  }
  if (!customElements.get('artikel-seite')) customElements.define('artikel-seite', ArtikelSeite);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bento-raster"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bento-raster')) {
    customElements.define(
      'bento-raster',
      class BentoRaster extends HTMLElement {
        connectedCallback() {
          this.kacheln = [...this.querySelectorAll('.bnt__kachel')];
          if (!this.kacheln.length) return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          if (!('IntersectionObserver' in window)) return;

          this.kacheln.forEach((k) => k.classList.add('ist-bereit'));
          this.beobachter = new IntersectionObserver(
            (eintraege) => {
              eintraege.forEach((e) => {
                if (!e.isIntersecting) return;
                e.target.classList.add('ist-da');
                this.beobachter.unobserve(e.target);
              });
            },
            { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
          );
          this.kacheln.forEach((k) => this.beobachter.observe(k));
        }

        disconnectedCallback() {
          if (this.beobachter) this.beobachter.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["claim-band"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('claim-band')) {
    customElements.define(
      'claim-band',
      class ClaimBand extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          if (!('IntersectionObserver' in window)) return;

          this.classList.add('claim--animiert');

          const beo = new IntersectionObserver(
            (eintraege) => {
              eintraege.forEach((e) => {
                if (!e.isIntersecting) return;
                e.target.classList.add('da');
                beo.unobserve(e.target);
              });
            },
            { threshold: 0.2 }
          );

          this.querySelectorAll('[data-auf]').forEach((el) => beo.observe(el));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["closing-tiles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('closing-tiles')) {
    customElements.define(
      'closing-tiles',
      class ClosingTiles extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          if (!('IntersectionObserver' in window)) return;

          this.classList.add('abschluss--animiert');

          const beo = new IntersectionObserver(
            (eintraege) => {
              eintraege.forEach((e) => {
                if (!e.isIntersecting) return;
                e.target.classList.add('da');
                beo.unobserve(e.target);
              });
            },
            { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
          );

          this.querySelectorAll('[data-auf]').forEach((el) => beo.observe(el));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["einsatz-karten"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('einsatz-karten')) {
    customElements.define(
      'einsatz-karten',
      class EinsatzKarten extends HTMLElement {
        connectedCallback() {
          this.karten = [...this.querySelectorAll('.eink__karte')];
          if (!this.karten.length) return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

          this.karten.forEach((k) => k.classList.add('ist-bereit'));
          this.beobachter = new IntersectionObserver(
            (eintraege) => {
              eintraege.forEach((e) => {
                if (!e.isIntersecting) return;
                e.target.classList.add('ist-da');
                this.beobachter.unobserve(e.target);
              });
            },
            { threshold: 0.12 }
          );
          this.karten.forEach((k) => this.beobachter.observe(k));
        }

        disconnectedCallback() {
          if (this.beobachter) this.beobachter.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["explosion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('explosion-ansicht')) {
    customElements.define(
      'explosion-ansicht',
      class ExplosionAnsicht extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          if (!('IntersectionObserver' in window)) return;

          this.classList.add('explo--animiert');

          const beo = new IntersectionObserver(
            (eintraege) => {
              eintraege.forEach((e) => {
                if (!e.isIntersecting) return;
                e.target.classList.add('da');
                beo.unobserve(e.target);
              });
            },
            { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
          );

          this.querySelectorAll('[data-auf]').forEach((el) => beo.observe(el));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faq-accordion')) {
    customElements.define(
      'faq-accordion',
      class FaqAccordion extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';

          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (reduced || !('IntersectionObserver' in window)) return;

          const targets = this.querySelectorAll('[data-reveal]');
          if (targets.length === 0) return;

          this.classList.add('faq--animate');

          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                entry.target.classList.add('is-in');
                observer.unobserve(entry.target);
              });
            },
            { threshold: 0.2, rootMargin: '0px 0px -8% 0px' }
          );

          targets.forEach((target) => observer.observe(target));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-check"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fit-check')) {
    customElements.define(
      'fit-check',
      class FitCheck extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';

          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (reduced || !('IntersectionObserver' in window)) return;

          this.classList.add('fitcheck--animate');

          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                entry.target.classList.add('is-in');
                observer.unobserve(entry.target);
              });
            },
            { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
          );

          this.querySelectorAll('[data-reveal]').forEach((el) => observer.observe(el));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fusszeile"] && !Shopify.designMode) return;
  try {
    
  class FussZeile extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;
      this.classList.add('fz--animiert');
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          this.classList.add('is-in');
          io.disconnect();
        });
      }, { threshold: 0.15 });
      io.observe(this);
    }
  }
  if (!customElements.get('fuss-zeile')) customElements.define('fuss-zeile', FussZeile);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  // Ticker aus den Reihen-Slides befuellen (Inhalt doppelt = nahtlose
  // Schleife). Laeuft das Skript nicht, bleibt das Band leer und die
  // stehende Reihe sichtbar (siehe :has-Regel im Stylesheet).
  document.querySelectorAll('.announcement-marquee__lauf').forEach((lauf) => {
    if (lauf.children.length > 0) return;
    const quelle = lauf
      .closest('.announcement-bar')
      .querySelectorAll('.announcement-bar__slide .announcement-bar__text');
    const texte = Array.from(quelle)
      .map((t) => t.textContent.trim())
      .filter(Boolean);
    if (texte.length === 0) return;
    for (let runde = 0; runde < 2; runde += 1) {
      texte.forEach((text) => {
        const s = document.createElement('span');
        s.textContent = text;
        lauf.appendChild(s);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-light"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hell-hero-video')) {
    customElements.define(
      'hell-hero-video',
      class HellHeroVideo extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          if (!this.video) return;

          this.video.muted = true;
          this.video.setAttribute('playsinline', '');
          this.video.setAttribute('disablepictureinpicture', '');

          // Hochkant-Video für Mobil: das passende Standbild setzen, bevor
          // das Video lädt. Die Quellenwahl selbst trifft der Browser über
          // das media-Attribut der <source>-Elemente.
          const posterMobil = this.dataset.posterMobile;
          if (posterMobil && window.matchMedia('(max-width: 749px)').matches) {
            this.video.poster = posterMobil;
          }

          // Ohne Bewegung bleibt das erste Bild stehen. Das Standbild des
          // Videos trägt die Aussage genauso, nur eben still.
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.video.removeAttribute('autoplay');
            this.video.pause();
            return;
          }

          // Außerhalb des Sichtfelds pausieren — spart Akku auf dem Handy.
          // Der Beobachter misst gegen das Fenster und ist deshalb vom
          // Scroll-Container .page-wrapper unabhängig.
          this.beobachter = new IntersectionObserver(
            (eintraege) => {
              eintraege.forEach((eintrag) => {
                if (eintrag.isIntersecting) {
                  const versuch = this.video.play();
                  if (versuch) versuch.catch(() => {});
                } else {
                  this.video.pause();
                }
              });
            },
            { threshold: 0.05 }
          );
          this.beobachter.observe(this);
        }

        disconnectedCallback() {
          if (this.beobachter) this.beobachter.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kapitel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kapitel-abschnitt')) {
    customElements.define(
      'kapitel-abschnitt',
      class KapitelAbschnitt extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          if (!('IntersectionObserver' in window)) return;

          this.classList.add('kap--animiert');

          const beo = new IntersectionObserver(
            (eintraege) => {
              eintraege.forEach((e) => {
                if (!e.isIntersecting) return;
                e.target.classList.add('da');
                beo.unobserve(e.target);
              });
            },
            { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
          );

          this.querySelectorAll('[data-auf]').forEach((el) => beo.observe(el));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kassen-angebot"] && !Shopify.designMode) return;
  try {
    
  class KassenAngebot extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';

      this.dialog = this.querySelector('dialog');
      this.produktId = Number(this.dataset.produkt);
      this.varianteId = Number(this.dataset.variante);
      this.wurzel = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      this.durchlassen = false;

      this.beimKlick = this.beimKlick.bind(this);
      document.addEventListener('click', this.beimKlick, true);
      this.querySelector('[data-ka-ja]').addEventListener('click', () => this.hinzufuegen());
      this.querySelector('[data-ka-nein]').addEventListener('click', () => this.weiter());
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.beimKlick, true);
    }

    gesehen() {
      try { return sessionStorage.getItem('kassen-angebot') === 'gesehen'; } catch (e) { return false; }
    }

    merken() {
      try { sessionStorage.setItem('kassen-angebot', 'gesehen'); } catch (e) { /* privat: dann eben erneut */ }
    }

    async beimKlick(event) {
      const knopf = event.target.closest('button[name="checkout"], input[name="checkout"]');
      if (!knopf || this.durchlassen || this.gesehen()) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      this.knopf = knopf;

      let zeigen = false;
      try {
        const abbruch = new AbortController();
        const frist = setTimeout(() => abbruch.abort(), 2000);
        const antwort = await fetch(this.wurzel + 'cart.js', { headers: { Accept: 'application/json' }, signal: abbruch.signal });
        clearTimeout(frist);
        const korb = await antwort.json();
        zeigen = korb.item_count > 0 && !korb.items.some((p) => p.product_id === this.produktId);
      } catch (e) {
        zeigen = false;
      }

      if (!zeigen) {
        this.weiter();
        return;
      }
      this.merken();
      this.dialog.showModal();
    }

    weiter() {
      if (this.dialog.open) this.dialog.close();
      this.durchlassen = true;
      if (this.knopf && this.knopf.isConnected) {
        this.knopf.click();
      } else {
        window.location.href = this.wurzel + 'checkout';
      }
    }

    async hinzufuegen() {
      const ja = this.querySelector('[data-ka-ja]');
      const fehler = this.querySelector('.ka__fehler');
      ja.disabled = true;
      ja.setAttribute('aria-busy', 'true');
      fehler.hidden = true;
      try {
        const antwort = await fetch(this.wurzel + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: this.varianteId, quantity: 1 }] }),
        });
        if (!antwort.ok) throw new Error(String(antwort.status));
        window.location.href = this.wurzel + 'checkout';
      } catch (e) {
        ja.disabled = false;
        ja.removeAttribute('aria-busy');
        fehler.hidden = false;
      }
    }
  }
  if (!customElements.get('kassen-angebot')) customElements.define('kassen-angebot', KassenAngebot);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kennzahlen-band"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kennzahlen-band')) {
    customElements.define(
      'kennzahlen-band',
      class KennzahlenBand extends HTMLElement {
        connectedCallback() {
          this.bahn = this.querySelector('.kzb__raster');
          this.zellen = [...this.querySelectorAll('.kzb__zelle')];
          if (!this.bahn || this.zellen.length < 2) return;

          this.leiste = document.createElement('div');
          this.leiste.className = 'kzb__punkte';
          this.punkte = this.zellen.map((zelle, i) => {
            const knopf = document.createElement('button');
            knopf.type = 'button';
            knopf.className = 'kzb__punkt';
            knopf.setAttribute('aria-label', 'Kennzahl ' + (i + 1) + ' von ' + this.zellen.length);
            knopf.setAttribute('aria-current', i === 0 ? 'true' : 'false');
            knopf.addEventListener('click', () => this.zeige(i));
            this.leiste.appendChild(knopf);
            return knopf;
          });
          this.appendChild(this.leiste);

          // Der Scroll-Container ist die Bahn selbst, nicht das Fenster —
          // hier feuert das Ereignis also, anders als bei .page-wrapper.
          this.beiScroll = () => {
            if (this.warte) return;
            this.warte = requestAnimationFrame(() => {
              this.warte = null;
              this.aktualisiere();
            });
          };
          this.bahn.addEventListener('scroll', this.beiScroll, { passive: true });

          // Punkte nur zeigen, solange die Bahn wirklich rollt. Auf dem
          // Schreibtisch steht wieder das Raster, dort wären sie sinnlos.
          this.pruefe = () => {
            const rollt = this.bahn.scrollWidth > this.bahn.clientWidth + 1;
            this.leiste.hidden = !rollt;
            if (rollt) {
              this.bahn.setAttribute('tabindex', '0');
              this.bahn.setAttribute('role', 'region');
              this.bahn.setAttribute('aria-label', 'Kennzahlen');
            } else {
              this.bahn.removeAttribute('tabindex');
              this.bahn.removeAttribute('role');
              this.bahn.removeAttribute('aria-label');
            }
            if (rollt) this.aktualisiere();
          };
          this.pruefe();
          this.beobachter = new ResizeObserver(() => this.pruefe());
          this.beobachter.observe(this.bahn);
        }

        aktualisiere() {
          const b = this.bahn.getBoundingClientRect();
          const mitte = b.left + b.width / 2;
          let beste = 0;
          let abstand = Infinity;
          this.zellen.forEach((zelle, i) => {
            const r = zelle.getBoundingClientRect();
            const d = Math.abs(r.left + r.width / 2 - mitte);
            if (d < abstand) {
              abstand = d;
              beste = i;
            }
          });
          this.punkte.forEach((punkt, i) => {
            punkt.setAttribute('aria-current', i === beste ? 'true' : 'false');
          });
        }

        zeige(i) {
          const zelle = this.zellen[i];
          if (!zelle) return;
          // Über die Rechtecke statt über offsetLeft: die Bahn ist nicht
          // positioniert, offsetLeft bezöge sich also auf ein anderes Element.
          const b = this.bahn.getBoundingClientRect();
          const z = zelle.getBoundingClientRect();
          const ziel = this.bahn.scrollLeft + (z.left - b.left) - (b.width - z.width) / 2;
          const ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.bahn.scrollTo({ left: ziel, behavior: ruhig ? 'auto' : 'smooth' });
        }

        disconnectedCallback() {
          if (this.beobachter) this.beobachter.disconnect();
          if (this.bahn && this.beiScroll) this.bahn.removeEventListener('scroll', this.beiScroll);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magazin-beitrag"]) return;
  try {
    
  /* Markiert im Inhaltsverzeichnis den Abschnitt, in dem man gerade liest.
     Ohne JavaScript bleiben die Sprungmarken voll nutzbar. Gescrollt wird in
     Horizons .page-wrapper, nicht im Fenster (CLAUDE.md §6). Scroll-Ereignisse
     steigen nicht auf, ein Lauscher in der Capture-Phase am document hört sie
     aber aus jedem Container. */
  class MagazinBeitrag extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';

      const links = [...this.querySelectorAll('.mb__liste a[href^="#abschnitt-"]')];
      const klapp = this.querySelector('.mb__klapp');
      links.forEach((a) => a.addEventListener('click', () => { if (klapp) klapp.open = false; }));
      if (!links.length) return;

      const ids = [...new Set(links.map((a) => a.getAttribute('href').slice(1)))];
      const koepfe = ids.map((id) => document.getElementById(id)).filter(Boolean);
      if (!koepfe.length) return;

      let aktiv = null;
      const setze = (id) => {
        if (id === aktiv) return;
        aktiv = id;
        links.forEach((a) => {
          if (a.getAttribute('href') === '#' + id) a.setAttribute('aria-current', 'location');
          else a.removeAttribute('aria-current');
        });
      };

      const pruefe = () => {
        const grenze = window.innerHeight * 0.3;
        let id = null;
        for (const k of koepfe) {
          if (k.getBoundingClientRect().top <= grenze) id = k.id;
          else break;
        }
        setze(id);
      };

      let geplant = false;
      this.beimScrollen = () => {
        if (geplant) return;
        geplant = true;
        requestAnimationFrame(() => { geplant = false; pruefe(); });
      };
      /* scrollend fängt das Ende eines weichen Sprungs ab, falls das letzte
         scroll-Ereignis vor der Endposition kam. */
      this.amEnde = pruefe;
      document.addEventListener('scroll', this.beimScrollen, { capture: true, passive: true });
      document.addEventListener('scrollend', this.amEnde, { capture: true, passive: true });
      pruefe();
    }

    disconnectedCallback() {
      if (this.beimScrollen) document.removeEventListener('scroll', this.beimScrollen, { capture: true });
      if (this.amEnde) document.removeEventListener('scrollend', this.amEnde, { capture: true });
    }
  }
  if (!customElements.get('magazin-beitrag')) customElements.define('magazin-beitrag', MagazinBeitrag);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pinned-stage"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pinned-stage')) {
    customElements.define(
      'pinned-stage',
      class PinnedStage extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';

          this.szenen = this.querySelectorAll('.szene');
          this.bilder = this.querySelectorAll('.buehne__bild');
          this.spur = this.querySelectorAll('.spur i');
          this.zaehler = this.querySelector('[data-zaehler]');
          this.aktiv = -1;

          // Bei einer einzigen Szene lohnt das Festheften nicht.
          if (this.szenen.length < 2) return;

          this.classList.add('ist-bereit');

          this.zeichnen = this.zeichnen.bind(this);
          this.anfordern = this.anfordern.bind(this);
          this.laeuft = false;

          // Horizon setzt overflow:hidden auf html und body und scrollt in
          // .page-wrapper. Ein Listener auf window feuert dort nie, deshalb
          // wird der tatsächliche Scroll-Container gesucht.
          this.behaelter = this.scrollContainer();
          this.behaelter.addEventListener('scroll', this.anfordern, { passive: true });
          window.addEventListener('resize', this.anfordern);
          this.zeichnen();
        }

        scrollContainer() {
          let el = this.parentElement;
          while (el && el !== document.body) {
            const oy = getComputedStyle(el).overflowY;
            if ((oy === 'auto' || oy === 'scroll') && el.scrollHeight > el.clientHeight) return el;
            el = el.parentElement;
          }
          return window;
        }

        disconnectedCallback() {
          if (this.behaelter) this.behaelter.removeEventListener('scroll', this.anfordern);
          window.removeEventListener('resize', this.anfordern);
        }

        anfordern() {
          if (this.laeuft) return;
          this.laeuft = true;
          requestAnimationFrame(() => {
            this.zeichnen();
            this.laeuft = false;
          });
        }

        zeichnen() {
          const rect = this.getBoundingClientRect();
          const lauf = rect.height - window.innerHeight;
          if (lauf <= 0) return;

          const anteil = Math.min(Math.max(-rect.top / lauf, 0), 0.9999);
          const index = Math.floor(anteil * this.szenen.length);
          if (index === this.aktiv) return;
          this.aktiv = index;

          this.szenen.forEach((s, i) => s.classList.toggle('aktiv', i === index));
          this.bilder.forEach((b, i) => b.classList.toggle('aktiv', i === index));
          this.spur.forEach((s, i) => s.classList.toggle('voll', i <= index));
          if (this.zaehler) this.zaehler.textContent = String(index + 1).padStart(2, '0');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["process-steps"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('process-steps')) {
    customElements.define(
      'process-steps',
      class ProcessSteps extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';

          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (reduced || !('IntersectionObserver' in window)) return;

          this.classList.add('process--animate');

          const targets = this.querySelectorAll('[data-reveal]');
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                entry.target.classList.add('is-in');
                observer.unobserve(entry.target);
              });
            },
            { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
          );

          targets.forEach((target) => observer.observe(target));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video"] && !Shopify.designMode) return;
  try {
    
  // Ton beim Start an: Horizon rendert das Video fest mit `muted`, weil es
  // sonst nicht automatisch anlaufen duerfte. Hier startet es aber erst auf
  // Klick - diese Nutzergeste erlaubt Ton, also wird direkt nach dem
  // Einfuegen entstummt. Delegiert am Dokument, damit die Reihenfolge von
  // Section-JS und DOM-Aufbau keine Rolle spielt.
  if (!window.__pvideoTonAn) {
    window.__pvideoTonAn = true;

    document.addEventListener('click', (event) => {
      const ziel = event.target;
      if (!(ziel instanceof Element)) return;

      const rahmen = ziel.closest('.pvideo__frame');
      if (!rahmen) return;

      // Das Video haengt erst nach Horizons Klick-Handler im DOM, deshalb
      // ueber einige Frames nachfassen.
      let versuche = 0;
      const tonAn = () => {
        const video = rahmen.querySelector('video');

        if (video) {
          video.muted = false;
          video.volume = 1;
          const start = video.play();
          if (start && typeof start.catch === 'function') start.catch(() => {});
          return;
        }

        if (versuche < 30) {
          versuche += 1;
          requestAnimationFrame(tonAn);
        }
      };

      tonAn();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reiter-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('reiter-video')) {
    customElements.define(
      'reiter-video',
      class ReiterVideo extends HTMLElement {
        connectedCallback() {
          this.reiter = [...this.querySelectorAll('.rvd__reiter')];
          this.szenen = [...this.querySelectorAll('.rvd__szene')];
          if (this.reiter.length < 2 || this.reiter.length !== this.szenen.length) return;

          // Erst hier stapeln: Ohne Skript stehen die Szenen untereinander
          // und bleiben vollständig lesbar.
          this.classList.add('ist-bereit');
          this.zeigen(0);

          this.reiter.forEach((knopf, i) => {
            knopf.addEventListener('click', () => this.zeigen(i));
            knopf.addEventListener('keydown', (e) => this.tasten(e, i));
          });
        }

        zeigen(index) {
          this.reiter.forEach((knopf, i) => {
            const aktiv = i === index;
            knopf.setAttribute('aria-selected', String(aktiv));
            knopf.tabIndex = aktiv ? 0 : -1;
          });

          this.szenen.forEach((szene, i) => {
            const aktiv = i === index;
            szene.classList.toggle('ist-da', aktiv);
            const film = szene.querySelector('video');
            if (!film) return;
            if (aktiv) {
              const versuch = film.play();
              if (versuch) versuch.catch(() => {});
            } else {
              film.pause();
            }
          });
        }

        // Pfeiltasten wechseln den Reiter, wie es für Tablisten erwartet wird.
        tasten(ereignis, i) {
          const letzte = this.reiter.length - 1;
          let ziel = null;
          if (ereignis.key === 'ArrowRight') ziel = i === letzte ? 0 : i + 1;
          else if (ereignis.key === 'ArrowLeft') ziel = i === 0 ? letzte : i - 1;
          else if (ereignis.key === 'Home') ziel = 0;
          else if (ereignis.key === 'End') ziel = letzte;
          if (ziel === null) return;
          ereignis.preventDefault();
          this.zeigen(ziel);
          this.reiter[ziel].focus();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-proof"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('social-proof')) {
    customElements.define(
      'social-proof',
      class SocialProof extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';

          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (reduced || !('IntersectionObserver' in window)) return;

          this.classList.add('sproof--animate');

          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                entry.target.classList.add('is-in');
                observer.unobserve(entry.target);
              });
            },
            { threshold: 0.2, rootMargin: '0px 0px -8% 0px' }
          );

          this.querySelectorAll('[data-reveal]').forEach((el) => observer.observe(el));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["steckbrief"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('steckbrief-tabelle')) {
    customElements.define(
      'steckbrief-tabelle',
      class SteckbriefTabelle extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          if (!('IntersectionObserver' in window)) return;

          this.classList.add('brief--animiert');

          const beo = new IntersectionObserver(
            (eintraege) => {
              eintraege.forEach((e) => {
                if (!e.isIntersecting) return;
                e.target.classList.add('da');
                beo.unobserve(e.target);
              });
            },
            { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
          );

          this.querySelectorAll('[data-auf]').forEach((el) => beo.observe(el));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tech-daten-produkt"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tech-daten-produkt')) {
    customElements.define(
      'tech-daten-produkt',
      class TechDaten extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';

          this.karussell();

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          if (!('IntersectionObserver' in window)) return;

          this.classList.add('tdprod--animiert');

          const beo = new IntersectionObserver(
            (eintraege) => {
              eintraege.forEach((e) => {
                if (!e.isIntersecting) return;
                if (e.target === this.bahn) {
                  this.karten.forEach((karte) => karte.classList.add('da'));
                } else {
                  e.target.classList.add('da');
                }
                beo.unobserve(e.target);
              });
            },
            { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
          );

          // Im Karussell steht immer nur eine Karte im Bild; die übrigen
          // sind seitlich abgeschnitten und würden einzeln beobachtet erst
          // beim Wischen erscheinen — man sähe eine leere Karte, die sich
          // nachträglich füllt. Dort löst deshalb die Bahn für alle aus.
          this.querySelectorAll('[data-auf]').forEach((el) => {
            if (this.bahnAktiv && el.classList.contains('tdprod__gruppe')) return;
            beo.observe(el);
          });
          if (this.bahnAktiv) beo.observe(this.bahn);
        }

        karussell() {
          this.bahn = this.querySelector('.tdprod__raster');
          this.karten = [...this.querySelectorAll('.tdprod__gruppe')];
          if (!this.bahn || this.karten.length < 2) return;

          this.leiste = document.createElement('div');
          this.leiste.className = 'tdprod__punkte';
          this.punkte = this.karten.map((karte, i) => {
            const knopf = document.createElement('button');
            knopf.type = 'button';
            knopf.className = 'tdprod__punkt';
            const name = karte.querySelector('.tdprod__titel');
            knopf.setAttribute('aria-label', name ? name.textContent.trim() : 'Gruppe ' + (i + 1));
            knopf.setAttribute('aria-current', i === 0 ? 'true' : 'false');
            knopf.addEventListener('click', () => this.zeige(i));
            this.leiste.appendChild(knopf);
            return knopf;
          });
          this.bahn.insertAdjacentElement('afterend', this.leiste);

          // Der Scroll-Container ist die Bahn selbst, nicht das Fenster —
          // hier feuert das Ereignis also, anders als bei .page-wrapper.
          this.beiScroll = () => {
            if (this.warte) return;
            this.warte = requestAnimationFrame(() => {
              this.warte = null;
              this.aktualisiere();
            });
          };
          this.bahn.addEventListener('scroll', this.beiScroll, { passive: true });

          this.pruefe = () => {
            const rollt = this.bahn.scrollWidth > this.bahn.clientWidth + 1;
            this.bahnAktiv = rollt;
            this.leiste.hidden = !rollt;
            if (rollt) {
              // Kein role="region": das nähme der Liste ihre Listenrolle.
              // Ein Name allein reicht, gerollt wird ohnehin.
              this.bahn.setAttribute('tabindex', '0');
              this.bahn.setAttribute('aria-label', 'Technische Daten');
              this.aktualisiere();
            } else {
              this.bahn.removeAttribute('tabindex');
              this.bahn.removeAttribute('aria-label');
            }
          };
          this.pruefe();
          this.groessenBeobachter = new ResizeObserver(() => this.pruefe());
          this.groessenBeobachter.observe(this.bahn);
        }

        aktualisiere() {
          const b = this.bahn.getBoundingClientRect();
          const mitte = b.left + b.width / 2;
          let beste = 0;
          let abstand = Infinity;
          this.karten.forEach((karte, i) => {
            const r = karte.getBoundingClientRect();
            const d = Math.abs(r.left + r.width / 2 - mitte);
            if (d < abstand) {
              abstand = d;
              beste = i;
            }
          });
          this.punkte.forEach((punkt, i) => {
            punkt.setAttribute('aria-current', i === beste ? 'true' : 'false');
          });
        }

        zeige(i) {
          const karte = this.karten[i];
          if (!karte) return;
          // Über die Rechtecke statt über offsetLeft: die Bahn ist nicht
          // positioniert, offsetLeft bezöge sich auf ein anderes Element.
          const b = this.bahn.getBoundingClientRect();
          const z = karte.getBoundingClientRect();
          const ziel = this.bahn.scrollLeft + (z.left - b.left) - (b.width - z.width) / 2;
          const ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.bahn.scrollTo({ left: ziel, behavior: ruhig ? 'auto' : 'smooth' });
        }

        disconnectedCallback() {
          if (this.groessenBeobachter) this.groessenBeobachter.disconnect();
          if (this.bahn && this.beiScroll) this.bahn.removeEventListener('scroll', this.beiScroll);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tech-daten"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tech-daten')) {
    customElements.define(
      'tech-daten',
      class TechDaten extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          if (!('IntersectionObserver' in window)) return;

          this.classList.add('techdaten--animiert');

          const beo = new IntersectionObserver(
            (eintraege) => {
              eintraege.forEach((e) => {
                if (!e.isIntersecting) return;
                e.target.classList.add('da');
                beo.unobserve(e.target);
              });
            },
            { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
          );

          this.querySelectorAll('[data-auf]').forEach((el) => beo.observe(el));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["technische-daten"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('technische-daten')) {
    customElements.define(
      'technische-daten',
      class TechnischeDaten extends HTMLElement {
        connectedCallback() {
          this.bahn = this.querySelector('.tdat__raster');
          this.karten = [...this.querySelectorAll('.tdat__gruppe')];
          if (!this.bahn || this.karten.length < 2) return;

          this.leiste = document.createElement('div');
          this.leiste.className = 'tdat__punkte';
          this.punkte = this.karten.map((karte, i) => {
            const knopf = document.createElement('button');
            knopf.type = 'button';
            knopf.className = 'tdat__punkt';
            const name = karte.querySelector('.tdat__gruppe-titel');
            knopf.setAttribute('aria-label', name ? name.textContent.trim() : 'Gruppe ' + (i + 1));
            knopf.setAttribute('aria-current', i === 0 ? 'true' : 'false');
            knopf.addEventListener('click', () => this.zeige(i));
            this.leiste.appendChild(knopf);
            return knopf;
          });
          this.appendChild(this.leiste);

          // Der Scroll-Container ist die Bahn selbst, nicht das Fenster —
          // hier feuert das Ereignis also, anders als bei .page-wrapper.
          this.beiScroll = () => {
            if (this.warte) return;
            this.warte = requestAnimationFrame(() => {
              this.warte = null;
              this.aktualisiere();
            });
          };
          this.bahn.addEventListener('scroll', this.beiScroll, { passive: true });

          this.pruefe = () => {
            const rollt = this.bahn.scrollWidth > this.bahn.clientWidth + 1;
            this.leiste.hidden = !rollt;
            if (rollt) {
              this.bahn.setAttribute('tabindex', '0');
              this.bahn.setAttribute('role', 'region');
              this.bahn.setAttribute('aria-label', 'Technische Daten');
              this.aktualisiere();
            } else {
              this.bahn.removeAttribute('tabindex');
              this.bahn.removeAttribute('role');
              this.bahn.removeAttribute('aria-label');
            }
          };
          this.pruefe();
          this.beobachter = new ResizeObserver(() => this.pruefe());
          this.beobachter.observe(this.bahn);
        }

        aktualisiere() {
          const b = this.bahn.getBoundingClientRect();
          const mitte = b.left + b.width / 2;
          let beste = 0;
          let abstand = Infinity;
          this.karten.forEach((karte, i) => {
            const r = karte.getBoundingClientRect();
            const d = Math.abs(r.left + r.width / 2 - mitte);
            if (d < abstand) {
              abstand = d;
              beste = i;
            }
          });
          this.punkte.forEach((punkt, i) => {
            punkt.setAttribute('aria-current', i === beste ? 'true' : 'false');
          });
        }

        zeige(i) {
          const karte = this.karten[i];
          if (!karte) return;
          // Über die Rechtecke statt über offsetLeft: die Bahn ist nicht
          // positioniert, offsetLeft bezöge sich auf ein anderes Element.
          const b = this.bahn.getBoundingClientRect();
          const z = karte.getBoundingClientRect();
          const ziel = this.bahn.scrollLeft + (z.left - b.left) - (b.width - z.width) / 2;
          const ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.bahn.scrollTo({ left: ziel, behavior: ruhig ? 'auto' : 'smooth' });
        }

        disconnectedCallback() {
          if (this.beobachter) this.beobachter.disconnect();
          if (this.bahn && this.beiScroll) this.bahn.removeEventListener('scroll', this.beiScroll);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('trust-bar')) {
    customElements.define(
      'trust-bar',
      class TrustBar extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';

          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (reduced || !('IntersectionObserver' in window)) return;

          this.classList.add('trustbar--animate');

          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                entry.target.classList.add('is-in');
                observer.unobserve(entry.target);
              });
            },
            { threshold: 0.2 }
          );

          this.querySelectorAll('[data-reveal]').forEach((el) => observer.observe(el));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["two-parts"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('two-parts')) {
    customElements.define(
      'two-parts',
      class TwoParts extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          if (!('IntersectionObserver' in window)) return;

          this.classList.add('paar--animiert');

          const beo = new IntersectionObserver(
            (eintraege) => {
              eintraege.forEach((e) => {
                if (!e.isIntersecting) return;
                e.target.classList.add('da');
                beo.unobserve(e.target);
              });
            },
            { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
          );

          this.querySelectorAll('[data-auf]').forEach((el) => beo.observe(el));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usp-karten"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('usp-karten')) {
    customElements.define(
      'usp-karten',
      class UspKarten extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          if (!('IntersectionObserver' in window)) return;

          this.classList.add('usps--animiert');

          const beo = new IntersectionObserver(
            (eintraege) => {
              eintraege.forEach((e) => {
                if (!e.isIntersecting) return;
                e.target.classList.add('da');
                beo.unobserve(e.target);
              });
            },
            { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
          );

          this.querySelectorAll('[data-auf]').forEach((el) => beo.observe(el));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-band"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-karte')) {
    customElements.define(
      'video-karte',
      class VideoKarte extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          this.taste = this.querySelector('.vib__start');
          if (!this.video || !this.taste) return;

          this.starten = () => {
            this.classList.add('laeuft');
            const versuch = this.video.play();
            if (versuch) versuch.catch(() => {});
            this.video.focus();
          };
          this.taste.addEventListener('click', this.starten);

          // Läuft ein anderer Clip an, hält dieser hier an.
          this.anhalten = (e) => {
            if (e.target !== this.video) this.video.pause();
          };
          document.addEventListener('play', this.anhalten, true);
        }

        disconnectedCallback() {
          if (this.taste && this.starten) this.taste.removeEventListener('click', this.starten);
          if (this.anhalten) document.removeEventListener('play', this.anhalten, true);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-text-buehne')) {
    customElements.define(
      'video-text-buehne',
      class VideoTextBuehne extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          this.taste = this.querySelector('.vtx__start');
          if (!this.video || !this.taste) return;

          this.starten = () => {
            this.classList.add('laeuft');
            this.video.controls = true;
            const versuch = this.video.play();
            if (versuch) versuch.catch(() => {});
            this.video.focus();
          };
          this.taste.addEventListener('click', this.starten);
        }

        disconnectedCallback() {
          if (this.taste && this.starten) this.taste.removeEventListener('click', this.starten);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["was-ist"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('was-ist')) {
    customElements.define(
      'was-ist',
      class WasIst extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';

          this.#lightbox();

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          if (!('IntersectionObserver' in window)) return;

          this.classList.add('wasist--animiert');

          const beo = new IntersectionObserver(
            (eintraege) => {
              eintraege.forEach((e) => {
                if (!e.isIntersecting) return;
                e.target.classList.add('da');
                beo.unobserve(e.target);
              });
            },
            { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
          );

          this.querySelectorAll('[data-auf]').forEach((el) => beo.observe(el));
        }

        /* Klick auf ein kleines Bild öffnet den Dialog; ohne JS führt der Link zum Bild.
           Pfeile und Pfeiltasten blättern mit Umlauf durch alle kleinen Bilder. */
        #lightbox() {
          const dialog = this.querySelector('.wasist__dialog');
          const bild = this.querySelector('.wasist__dialog-bild');
          const schliessen = this.querySelector('.wasist__dialog-schliessen');
          if (!dialog || !bild || typeof dialog.showModal !== 'function') return;

          const links = [...this.querySelectorAll('.wasist__mini-link')];
          let aktuell = 0;

          if (links.length < 2) dialog.classList.add('wasist__dialog--einzeln');

          const zeigen = (index) => {
            aktuell = (index + links.length) % links.length;
            const link = links[aktuell];
            bild.src = link.dataset.gross;
            bild.alt = link.dataset.alt || '';
          };

          links.forEach((link, index) => {
            link.addEventListener('click', (e) => {
              e.preventDefault();
              zeigen(index);
              dialog.showModal();
            });
          });

          dialog.querySelector('.wasist__dialog-pfeil--zurueck')?.addEventListener('click', () => zeigen(aktuell - 1));
          dialog.querySelector('.wasist__dialog-pfeil--vor')?.addEventListener('click', () => zeigen(aktuell + 1));

          dialog.addEventListener('keydown', (e) => {
            if (links.length < 2) return;
            if (e.key === 'ArrowLeft') zeigen(aktuell - 1);
            if (e.key === 'ArrowRight') zeigen(aktuell + 1);
          });

          schliessen?.addEventListener('click', () => dialog.close());

          dialog.addEventListener('click', (e) => {
            if (e.target === dialog) dialog.close();
          });

          dialog.addEventListener('close', () => {
            bild.src = '';
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
